import { getStorage, setStorage } from "./utils";

export function getSmsType() {
  return getStorage('uspeedo-wx-smsType') || 'Text';
}

export function setSmsType(value) {
  setStorage('uspeedo-wx-smsType', value);
  window.location.reload() // 强制页面刷新

  return value;
}